import { render } from "./Heroes.vue?vue&type=template&id=cdd2c676"
import script from "./Heroes.vue?vue&type=script&lang=js"
export * from "./Heroes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/statistics/player/Heroes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdd2c676"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdd2c676', __exports__)) {
    api.reload('cdd2c676', __exports__)
  }
  
  module.hot.accept("./Heroes.vue?vue&type=template&id=cdd2c676", () => {
    api.rerender('cdd2c676', render)
  })

}


export default __exports__